var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9053 12.1553C18.1982 11.8624 18.1982 11.3876 17.9053 11.0947L12.9053 6.09467C12.6124 5.80178 12.1376 5.80178 11.8447 6.09467C11.5518 6.38756 11.5518 6.86244 11.8447 7.15533L15.5643 10.875H2.375C1.96079 10.875 1.625 11.2108 1.625 11.625C1.625 12.0392 1.96079 12.375 2.375 12.375H15.5643L11.8447 16.0947C11.5518 16.3876 11.5518 16.8624 11.8447 17.1553C12.1376 17.4482 12.6124 17.4482 12.9053 17.1553L17.9053 12.1553Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.966 18.216L18.966 13.216C19.8447 12.3373 19.8447 10.9127 18.966 10.034L13.966 5.03401C13.5267 4.59467 12.9508 4.375 12.375 4.375V3.625C12.375 2.52043 13.2704 1.625 14.375 1.625H20.375C21.4796 1.625 22.375 2.52043 22.375 3.625V19.625C22.375 20.7296 21.4796 21.625 20.375 21.625H14.375C13.2704 21.625 12.375 20.7296 12.375 19.625V18.875C12.9508 18.875 13.5267 18.6553 13.966 18.216Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.9aff1c852fe4e2a4a9c483467895341a.svg";
export { ForwardRef as ReactComponent };